import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

angular
  .module('bringoz.admin.billing-accounts')
  .factory('$billingOrders', BillingOrdersObjectFactory);

/* @ngInject */
function BillingOrdersObjectFactory($bringozFactory: $bringozFactory,
                                    BillingOrdersAPI: BringozApi,
                                    BillingOrders_DS: DataStoreConfig,
                                    BillingOrders_PN: PushNotificationsConfig) {
  function $billingOrders(id: string) {
    return $bringozFactory(id, BillingOrdersAPI, BillingOrders_DS, BillingOrders_PN)
  }

  return $billingOrders;
}
